//кнопка вверх
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() > 10) {
      $('#scroll').css('display', 'block');
    }
    else {
      $('#scroll').css('display', 'none');
    }
  });

  $('#toTop').click(function () {
    $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
    return false;
  });

  //Карта
  $('header .adress').click(function () {
    $("html, body").animate({scrollTop: $('.map').offset().top}, "slow");
  });

  //Плавающий блок услуг
  if (document.querySelector('.plav-block')) {
    jQuery(window).resize(function () {
      if ($(window).width() > 768) {
        $(window).scroll(function () {
          if ($(document).scrollTop() > 230) {
            $('.plav-block .right-form').addClass('go');
          }
          else {
            $('.plav-block .right-form').removeClass('go');
          }

          var blockForm = $('.plav-block .right-form').height();
          if ($(document).scrollTop() > $('.other-service').offset().top - 540) {
            $('.plav-block .right-form').addClass('stop-go');
          }
          else {
            $('.plav-block .right-form').removeClass('stop-go');
          }
        })
      }
    });
    if ($(window).width() > 768) {
      $(window).scroll(function () {
        if ($(document).scrollTop() > 230) {
          $('.plav-block .right-form').addClass('go');
        }
        else {
          $('.plav-block .right-form').removeClass('go');
        }

        var blockForm = $('.plav-block .right-form').height();
        if ($(document).scrollTop() > $('.other-service').offset().top - 540) {
          $('.plav-block .right-form').addClass('stop-go');
        }
        else {
          $('.plav-block .right-form').removeClass('stop-go');
        }
      })
    }
  };

  //Плавающий блок услуг
  if (document.querySelector('.plav-block-form')) {
    // jQuery(window).resize(function () {
    //   if ($(window).width() > 768) {
    //     $(window).scroll(function () {
    //       if ($(document).scrollTop() > 230) {
    //         $('.plav-block-form .right-form').addClass('go');
    //       }
    //       else {
    //         $('.plav-block-form .right-form').removeClass('go');
    //       }
    //
    //       var blockForm = $('.plav-block-form .right-form').height();
    //       if ($(document).scrollTop() > $('.partners').offset().top - 680) {
    //         $('.plav-block-form .right-form').addClass('stop-go');
    //       }
    //       else {
    //         $('.plav-block-form .right-form').removeClass('stop-go');
    //       }
    //     })
    //   }
    // });
    if ($(window).width() > 768) {
      $(window).scroll(function () {
        if ($(document).scrollTop() > 230) {
          $('.plav-block-form .right-form').addClass('go');
        }
        else {
          $('.plav-block-form .right-form').removeClass('go');
        }

        var blockForm = $('.plav-block-form .right-form').height();
        if ($(document).scrollTop() > $('.partners').offset().top - 680) {
          $('.plav-block-form .right-form').addClass('stop-go');
        }
        else {
          $('.plav-block-form .right-form').removeClass('stop-go');
        }
      })
    }
  };

  updatePageWidget();
});

if (document.getElementsByClassName('image-text-link').length > 0) {
  $('.image-text-link').magnificPopup({type: 'image'});
}

function updatePageWidget() {
  let articles = document.querySelectorAll('[data-article-id]');
  let articles_ids = [];

  articles.forEach(function (item, i, arr) {
    articles_ids.push(item.getAttribute('data-article-id'));
  });

  axios.post('/update-page-widget', {articles_ids: articles_ids})
      .then(response => {
        let data = response.data;

        if (document.querySelector('.article-item')) {
          articles.forEach(function (item, i, arr) {
            let id = item.getAttribute('data-article-id');
            item.querySelector('.show-counter').textContent = data['articles'][id].shows;
            item.querySelector('.comment-counter').textContent = data['articles'][id].comments;
          });
        }
      });
}



if ($(window).width() < 756) {
  $('.mob-menu').click(function () {
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('header .bottom').removeClass('show-menu');
      $('header .sub-ul').removeClass('open');
    }
    else {
      $(this).addClass('active');
      $('header .bottom').addClass('show-menu');
    }
  });
  $('.contact-menu').click(function () {
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('header .cont-mob-block').removeClass('open-block');
    }
    else {
      $(this).addClass('active');
      $('header .cont-mob-block').addClass('open-block');
    }
  });
  $('.mob-exp').click(function () {
    if($(this).hasClass('hidden')) {
      $(this).removeClass('hidden');
      $(this).parent().children('ul').removeClass('open');
      $(this).parent().children().children('ul.list-inline').removeClass('open');
    }
    else {
      $(this).addClass('hidden');
      $(this).parent().children('ul').addClass('open');
      $(this).parent().children().children('ul.list-inline').addClass('open');
    }
  });
  $('.dop-services .dop-serv-block').after($('.dop-services .more-serv'));
}
else {
  $('.mob-after').after($('.dop-services .more-serv'));
}



//приплывание меню на заданные позиции
$('.ancor-block li:nth-child(1)').click(function () {
  var screen = $('.ancor-1').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(2)').click(function () {
  var screen = $('.ancor-2').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(3)').click(function () {
  var screen = $('.ancor-3').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(4)').click(function () {
  var screen = $('.ancor-4').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(5)').click(function () {
  var screen = $('.ancor-5').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(6)').click(function () {
  var screen = $('.ancor-6').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(7)').click(function () {
  var screen = $('.ancor-7').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(8)').click(function () {
  var screen = $('.ancor-8').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(9)').click(function () {
  var screen = $('.ancor-9').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});
$('.ancor-block li:nth-child(10)').click(function () {
  var screen = $('.ancor-10').offset().top - ($(window).height() / 30) + 25;
  $('html,body').animate({scrollTop: screen}, 800);
  return false;
});


$('.changed-link').click(function () {
  $(this).toggleClass('active');
  $('.cities-block').toggleClass('open-block');
});



//mobile-menu
$('.mob-link').click(function () {
  $(this).parent().children('.sub-ul').addClass('open');
});

$('.back-mobile').click(function () {
  $(this).parent().removeClass('open');
});

$('.open-sub-ul').click(function () {
  $(this).parent().children('.sub-ul').addClass('open');
});

$('.mob-services-click').click(function () {
  $('.mob-menu').addClass('active');
  $('header .bottom').addClass('show-menu');
  $('header .bottom .expanded:nth-child(2)>.sub-ul').addClass('open');
});


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/common.js